import { render, staticRenderFns } from "./menu-maps.vue?vue&type=template&id=6dea6d66&"
import script from "./menu-maps.vue?vue&type=script&lang=js&"
export * from "./menu-maps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports